export function useBranchParams() {
  // Get api-key from query parameters (less sensitive)
  const url = new URL(window.location.href)
  const apiKey = url.searchParams.get('api-key')
  
  // Get branch-client-token from URI fragment (more sensitive)
  const hash = window.location.hash.substring(1) // Remove the #
  const fragmentParams = new URLSearchParams(hash)
  const token = fragmentParams.get('branch-client-token')
  
  // Log security method for debugging
  console.debug('Using hybrid authentication: api-key from query, token from fragment')
  
  // Validate required parameters
  if (!apiKey || !token) {
    console.error('Missing required parameters: api-key and branch-client-token are required')
    console.error('Use format: ?api-key=YOUR_KEY#branch-client-token=YOUR_TOKEN')
    throw new Error('Missing required parameters: api-key and branch-client-token are required')
  }

  // Validate API key format
  if (!/^[a-zA-Z0-9_-]+$/.test(apiKey)) {
    console.error('Invalid API key format')
    throw new Error('Invalid API key format')
  }

  // Validate token format (JWT tokens contain dots and equals signs)
  if (!/^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*=*$/.test(token)) {
    console.error('Invalid token format')
    throw new Error('Invalid token format')
  }

  return { apiKey, token }
}
  